import OnlineEventMixin from '@/utils/mixins/OnlineEventMixin'
export default {
  mixins: [OnlineEventMixin],
  computed: {
    eventStatusType() {
      if (this.event.status === 'cancelled') return 'https://schema.org/EventCancelled'
      if (this.event.status === 'available') return 'https://schema.org/EventScheduled'
    }
  },
  methods: {
    offersByTicketInfo(event, tickets) {
      if (!tickets) return []
      return tickets.map(ticket => {
        const price = event.goto_campaign_event ? ticket.goto_campaign_event_ticket_price : ticket.price
        return {
          '@type': 'Offer',
          name: `${this.$useI18(`ticket.attributes.name.${ticket.gender}`)}${ticket.num_of_people}${ticket.num_of_people > 1 ? '人1組' : '人'}`,
          price: price,
          priceCurrency: 'JPY',
          validFrom: event.first_published_at,
          availability: ticket.adjust ? 'https://schema.org/SoldOut' : 'https://schema.org/InStock',
          url: `${import.meta.env.ROOT_URL}/events/${event.code}/`
        }
      })
    }
  }
}
